import { Panel } from "@poseidon/ui/components/Panel";
import {
  FormikDisabler,
  usePermissions,
} from "@poseidon/ui/components";
import React, { useEffect } from "react";
import Form from "@poseidon/ui/components/form/FullWidthForm";
import { Box, InputAdornment, Stack } from "@mui/material";
import { Field, Formik } from "formik";
import { TextField } from "formik-mui";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { useToastMessage } from "@poseidon/ui/app/toasts/useToastMessage";
import LinearProgress from "@mui/material/LinearProgress";
import { useBaseRate } from "./useBaseRate";
import { useUpdateBaseRate } from "./useUpdateBaseRate";
import LoadingButton from "@mui/lab/LoadingButton";

const BaseRateForm = ({
  handleSubmit,
  initialValues,
  resetForm,
  isSubmitting,
  dirty,
  canWrite,
}) => {
  useEffect(() => {
    resetForm();
  }, [initialValues, resetForm]);

  return (
    <Form onSubmit={handleSubmit}>
      <FormikDisabler disabled={!canWrite} />
      <Stack spacing={2} mb={3}>
        <Box>
          <Field
            component={TextField}
            name="baseRate"
            label="Base Rate"
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
              type: "number",
            }}
            margin="normal"
          />
        </Box>
        <Box>
          <LoadingButton
            loading={isSubmitting}
            disabled={!dirty || !canWrite}
            variant="contained"
            color="primary"
            type="submit"
            margin="normal"
          >
            Save
          </LoadingButton>
        </Box>
      </Stack>
    </Form>
  );
};

export const BaseRate = () => {
  const { canWrite } = usePermissions();
  const { setError } = useErrorMessage();
  const { setToast } = useToastMessage();
  const { baseRate, loading } = useBaseRate();
  const { updateBaseRate } = useUpdateBaseRate();
  if (loading || !baseRate) {
    return <LinearProgress />;
  }

  const onSubmitHandler = async (values, { resetForm, setSubmitting }) => {
    try {
      setSubmitting(true);
      updateBaseRate(values.baseRate).then(({ success }) => {
        setSubmitting(false);
        if (success) {
          resetForm();
          setToast("Updated");
        } else {
          setError("Unknown error");
        }
      });
    } catch (error) {
      setError(error.message);
    }
  };
  const initialValues = {
    baseRate,
  };

  return (
    <Panel title="Base Rate">
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={onSubmitHandler}
      >
        {(formikProps) => <BaseRateForm {...formikProps} canWrite={canWrite} />}
      </Formik>
    </Panel>
  );
};
